/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '@/utils/request';
// 工单详情
export var getAdmInfo = function getAdmInfo(param) {
  return request({
    url: '/index/index/getAdmInfo',
    method: 'post',
    data: param
  });
};